import React from 'react';

import {IMG_DIR} from '#Client/components/constants';
import {IconButton} from '#Client/components/IconButton/IconButton';
import {Modal} from '#Client/components/Modal/Modal';
import {outdatedMessage} from '#Client/components/OutdatedModal/OutdatedModal.css';
import {trackEvent} from '#Client/components/util';

type OutdatedModalProps = {
  difficulty: number;
  onClose: () => void;
  updateDifficulty: (difficulty: number) => void;
};

export const OutdatedModal = ({
  difficulty,
  onClose,
  updateDifficulty,
}: OutdatedModalProps) => {
  const refresh = () => {
    trackEvent('click', 'outdated-modal', 'button', 'refresh');
    onClose();
    if (difficulty === 9) {
      location.reload();
    } else {
      updateDifficulty(9);
    }
  };
  return (
    <Modal
      image={`${IMG_DIR}icon_stopwatch.png`}
      title="New puzzles!"
      onClose={onClose}
    >
      <>
        <h2>Welcome back!</h2>
        <div className={outdatedMessage}>
          You are currently viewing old puzzles. Please click below to play
          today&apos;s puzzles.
        </div>
        <div className="textAlignCenter">
          <IconButton
            icon="btn_icon_puzzle.png"
            large
            text="Play"
            onClick={refresh}
          />
        </div>
      </>
    </Modal>
  );
};
